var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "searchCard" }, [
    _c(
      "div",
      { staticClass: "searchCard__box searchCard__boxRegionalBoost" },
      [
        _c(
          "div",
          {
            staticClass:
              "searchCard__head flex flex__justifyItems--start flex__alignItems--center",
          },
          [
            _c(
              "svg",
              {
                staticClass: "searchIcon--32 searchIcon__right",
                attrs: { height: "32", width: "32", "aria-hidden": "true" },
              },
              [_c("use", { attrs: { href: "#iconBoostDuo" } })]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "searchCard__headline" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("FORM_SEARCH_REGION_FOCUS")) +
                  "\n            "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "facetedSearch__subHeadline flex flex__justifyItems--start flex__alignItems--center",
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("FORM_SEARCH_REGION_FOCUS_DESCRIPTION")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c("CustomDropdown", {
          attrs: {
            id: "inlineDropdown__regionalFocus",
            "datasty-gtm": "regional--focus",
            default: _vm.filterOptions[0],
            value: _vm.filterOption,
            disabled: _vm.hideFocusFilter,
            options: _vm.filterOptions,
            element: "rf-",
            bordered: true,
          },
          on: { changeValue: _vm.selectFilter },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }